import { Component } from "@angular/core";
import { FieldType, FieldTypeConfig } from "@ngx-formly/core";

@Component({
    standalone: false,
    templateUrl: "./colour-picker.component.html",
})
export class FormlyColourPicker extends FieldType<FieldTypeConfig> {
    color: string;

    constructor() {
        super();
    }
}
